/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import { useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData } from '../../../services/CryptoService';
import { setDropdownOptions } from '../../../components/finalForms/libs/mapDropdownOptions';
import { FieldSettingType } from '../../../utils/Enums/commonEnums';
import { setFieldSetting } from '../../../utils/FormFields/FieldsSetting/SetFieldSetting';

/** Common Components */
import FormCreator from '../../../components/finalForms/FormCreator';
import Buttons from '../../../components/ui/button/Buttons';
import { AppIcons } from '../../../data/appIcons';
import CardSection from '../../../components/ui/card/CardSection';
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid';

/** Common Services & Data Files */
import ToastService from '../../../services/toastService/ToastService';
import SwalAlert from '../../../services/swalService/SwalService';

/** Configuration Files */
import { GroupProjectGridConfig, groupProjectData } from '../config/GroupProject.data';

/** RTK Query */
import { 
    useAddGroupProjectMutation, 
    useDeleteGroupProjectMutation, 
    useLazyGetGroupProjectsByGroupIdQuery, 
    useLazyGetUnassignGroupProjectsByGroupIdQuery 
} from '../../../app/services/groupProjectAPI';

const GroupProject = () => {
    const groupProjectRef = useRef();
    const groupProjectFormRef = useRef();
    const { confirm } = SwalAlert();

    const { id } = useParams();
    const groupId = id ? decryptUrlData(id) : null;

    const [groupProjectForm, setGroupProjectForm] = useState({ ...groupProjectData });
    const [dataSource, setDataSource] = useState([]);

    const [getGroupProjectsByGroupId, {
        isLoading: isGroupProjectsByGroupIdLoading,
        isSuccess: isGroupProjectsByGroupIdSuccess,
        data: groupProjectsByGroupIdData
    },
    ] = useLazyGetGroupProjectsByGroupIdQuery();

    const [getUnassignGroupProjectsByGroupId, {
        isLoading: isUnassignGroupProjectsByGroupIdLoading,
        isSuccess: isUnassignGroupProjectsByGroupIdSuccess,
        data: unassignGroupProjectsByGroupIdData
    },
    ] = useLazyGetUnassignGroupProjectsByGroupIdQuery();

    const [addGroupProject, {
        isSuccess: isaddGroupProjectSuccess,
        data: addGroupProjectData
    },
    ] = useAddGroupProjectMutation();

    const [deleteGroupProject, {
        isSuccess: isdeleteGroupProjectSuccess,
        data: GroupProjectdata
    },] = useDeleteGroupProjectMutation();

    useEffect(() => {
        if (groupId) {
            getGroupProjectsByGroupId(groupId);
            getUnassignGroupProjectsByGroupId(groupId);
        }
    }, [groupId])


    useEffect(() => {
        if (!isUnassignGroupProjectsByGroupIdLoading && isUnassignGroupProjectsByGroupIdSuccess && unassignGroupProjectsByGroupIdData) {
            setDropdownOptions(unassignGroupProjectsByGroupIdData, 'projectId', 'projectName', groupProjectForm, 'groupProject', setGroupProjectForm);
            setFieldSetting(groupProjectForm, 'groupProject', FieldSettingType.ISFIELDDATALOADING, false);
        }
    }, [isUnassignGroupProjectsByGroupIdLoading, isUnassignGroupProjectsByGroupIdSuccess, groupProjectsByGroupIdData,])


    useEffect(() => {
        if (!isGroupProjectsByGroupIdLoading && isGroupProjectsByGroupIdSuccess && groupProjectsByGroupIdData) {
            setDataSource(groupProjectsByGroupIdData);
        }
    }, [isGroupProjectsByGroupIdLoading, isGroupProjectsByGroupIdSuccess, groupProjectsByGroupIdData,])

    const handleGroupProject = () => {
        const groupProjectData = groupProjectFormRef.current.getFormData();
        if (groupProjectData) {
            const projectIds = groupProjectData.groupProject.join(",");
            const requestData = {
                projectIds: projectIds,
                groupId: groupId,
            };
            addGroupProject(requestData);
        }
    }


    useEffect(() => {
        if (isaddGroupProjectSuccess && addGroupProjectData) {
            if (addGroupProjectData.errorMessage.includes("exists")) {
                ToastService.warning(addGroupProjectData.errorMessage);
                return;
            } else {
                ToastService.success(addGroupProjectData.errorMessage);
                getGroupProjectsByGroupId(groupId);
                getUnassignGroupProjectsByGroupId(groupId);
                resetForm();
            }
        }
    }, [isaddGroupProjectSuccess, addGroupProjectData])

    const onDeleteAction = (data) => {
        confirm(
            "Delete?",
            "Are you sure you want to Delete?",
            "Delete",
            "Cancel"
        ).then((confirmed) => {
            if (confirmed) {
                deleteGroupProject(data?.groupProjectId);
            }
        });
    };

    const resetForm = () => {
        const form = { ...groupProjectData }
        form.initialState = { ...groupProjectData.initialState };
        setGroupProjectForm(form);
    }

    useEffect(() => {
        if (isdeleteGroupProjectSuccess && GroupProjectdata) {
            if (GroupProjectdata.errorMessage.includes("exists")) {
                ToastService.warning(GroupProjectdata.errorMessage);
                return;
            } else {
                ToastService.success(GroupProjectdata.errorMessage);
                getGroupProjectsByGroupId(groupId);
                getUnassignGroupProjectsByGroupId(groupId);
                resetForm();
            }
        }
    }, [isdeleteGroupProjectSuccess, GroupProjectdata])

    const actionHandler = {
        DELETE: onDeleteAction,
    };

    return (
        <div className='group-project-sec'>
            <CardSection>
                <div className='select-group-Project row'>
                    <div className='col-12 d-flex justify-content-between'>
                        <div className='form-card row col-6'>
                            <FormCreator config={groupProjectForm} ref={groupProjectFormRef} />
                        </div>

                        <div className="row mt-3">
                            <div className="form-btn">
                                <Buttons
                                    buttonTypeClassName="theme-btn ml-4 mt-2"
                                    onClick={handleGroupProject}
                                    buttonText="Group Project"
                                    textWithIcon={true}
                                    iconName="material-symbols:add-rounded"
                                    imagePath={AppIcons.AddIcon}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='group-project-grid col-12  team-project-grid'>
                    <FinalMolGrid
                        ref={groupProjectRef}
                        configuration={GroupProjectGridConfig}
                        dataSource={dataSource}
                        onActionChange={actionHandler}
                        allowPagination={false}
                    />
                </div>
            </CardSection>
        </div>
    )
}

export default GroupProject